import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {UserRoutingModule} from './user-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {UserService} from './user.service';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserEditTypeComponent } from './user-edit-type/user-edit-type.component';
import {AuthModule} from '../auth/auth.module';

@NgModule({
  declarations: [
    UserEditComponent,
    UserEditTypeComponent,
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AuthModule
  ],
  providers: [
    UserService
  ]
})
export class UserModule {}
